module.exports = __webpack_public_path__ + "img/password.91746f65.svg";